module.exports = __webpack_public_path__ + "media/images/twitter_sidebar_image-9b613d381751d977966e707e1407fe4f.png";